import {Component, ViewEncapsulation} from '@angular/core';
import {NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';

@Component({
  selector: 'app-pre-enroll',
  templateUrl: './pre-enroll.component.html',
  styleUrls: ['./pre-enroll.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PreEnrollComponent {

  constructor(public nav: NavigateService, public cart: CartService) {}


  onBack() {
    this.cart.removeOneElementOLD('document_type');
    this.nav.to('document-management');
  }
}
